<template>
  <div></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Logout',
  created: function () {
    console.log('Asking to Logout')
    this.$store.commit('loggedOut')

    axios.post('/auth/logout')
      .then(resp => {
        // if any post logout url is present then redirect there
        this.handleLogout()
      }, err => {
        console.error('error in logout', err)
        this.handleLogout()
      })
  },
  methods: {
    handleLogout: function () {
      let postLogout = this.$store.state.keyValues.filter(kv => kv.theKey === 'LogoutUrl')
      console.log('LogoutUrl Found?', postLogout.length > 0)
      if (postLogout.length === 0) {
        console.log('std logout')
        this.$router.push('login')
      } else {
        let url = postLogout[0].theValue
        console.log('custom logout', url)
        window.location.href = url
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue